import React from 'react';
import { featuredCategories, brandLogos } from '../data/mock';
import * as Icons from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const FeaturedCategories = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  const getIcon = (iconName) => {
    const Icon = Icons[iconName];
    return Icon ? <Icon className="w-8 h-8" /> : null;
  };

  return (
    <section ref={ref} className={`py-16 bg-white fade-in-up ${isVisible ? 'visible' : ''}`}>
      <div className="pp-container">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            دسته بندی محصولات
          </h2>
          <p className="text-gray-600">محصولات برتر صنعتی با کیفیت تضمینی</p>
        </div>

        {/* Brand Logos */}
        <div className="mb-12 pb-8 border-b border-gray-200">
          <div className="flex flex-wrap justify-center items-center gap-8">
            {brandLogos.map((brand) => (
              <div
                key={brand.id}
                className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="h-12 object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {featuredCategories.map((category) => (
            <div
              key={category.id}
              className="group bg-white border border-gray-200 rounded-xl p-6 hover:border-[#005bbb] hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="text-center space-y-3">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full group-hover:bg-[#005bbb] group-hover:text-white transition-colors">
                  {getIcon(category.icon)}
                </div>
                <h3 className="text-sm font-semibold text-gray-900 group-hover:text-[#005bbb] transition-colors">
                  {category.name}
                </h3>
                <p className="text-xs text-gray-500">{category.count} محصول</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;